(function () {
  function init() {
    var sentinel = document.querySelector('[data-sticky-cta-sentinel]');
    var bar = document.querySelector('[data-sticky-cta-bar]');
    if (!sentinel || !bar || !window.IntersectionObserver) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', scrolledPast);
        });
      },
      { threshold: 0 }
    );

    observer.observe(sentinel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
